/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminOrderPaymentType = {
    OrderPaymentTypeCash: 'cash',
    OrderPaymentTypeZelle: 'zelle',
    OrderPaymentTypePaypal: 'paypal',
    OrderPaymentTypeVenmo: 'venmo',
    OrderPaymentTypeMarketplace: 'marketplace'
} as const;
export type AdminOrderPaymentType = typeof AdminOrderPaymentType[keyof typeof AdminOrderPaymentType];


export function instanceOfAdminOrderPaymentType(value: any): boolean {
    for (const key in AdminOrderPaymentType) {
        if (Object.prototype.hasOwnProperty.call(AdminOrderPaymentType, key)) {
            if (AdminOrderPaymentType[key as keyof typeof AdminOrderPaymentType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminOrderPaymentTypeFromJSON(json: any): AdminOrderPaymentType {
    return AdminOrderPaymentTypeFromJSONTyped(json, false);
}

export function AdminOrderPaymentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminOrderPaymentType {
    return json as AdminOrderPaymentType;
}

export function AdminOrderPaymentTypeToJSON(value?: AdminOrderPaymentType | null): any {
    return value as any;
}

export function AdminOrderPaymentTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminOrderPaymentType {
    return value as AdminOrderPaymentType;
}

